import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('DocumentModel', DocumentModelData);

    DocumentModelData.$inject = ['Attribute'];

    /* @ngInject */
    function DocumentModelData(Attribute) {
        DocumentModel.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getAttByCategory: getAttByCategory,
            getAttBySection: getAttBySection,
            addAttributes: addAttributes,
        };

        function DocumentModel(documentModel) {
            if (!documentModel) {
                this.buildEmpty();
            } else {
                this.build(documentModel);
            }
        }

        return DocumentModel;

        /////////////////////

        function buildEmpty() {
            this.name = null;
            this.description = null;
            this.attributes = [];
        }

        function build(documentModel) {
            this.name = documentModel.name || null;
            this.description = documentModel.description || null;
            this.attributes = _.map(_.orderBy(documentModel.attributes, 'order'), function (a) {
                return new Attribute(a);
            });
        }

        function getAttByCategory(category) {
            return _.filter(this.attributes, { category: category });
        }

        function getAttBySection(section) {
            return _.filter(this.attributes, a => a.section === section && a.type !== 'Composite');
        }

        function addAttributes(addedAttributes) {
            return _.orderBy(this.attributes.concat(addedAttributes), 'order');
        }
    }
})();
